import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/main.scss';

import { library } from '@fortawesome/fontawesome-svg-core'

import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Signup from './pages/auth/Signup';
import ProfileSetup from './pages/customer/ProfileSetup';
import Reports from './pages/Reports';
import Transactions from './pages/Transactions';
import Tickets from './pages/ticket';
import TicketView from './pages/ticket/View';
import Invoices from './pages/invoice';
import Paycode from './pages/paycode';
import Voucher from './pages/voucher';
import BillsPayment from './pages/billspayment';
import Wallets from './pages/wallets';
import P2pPayment from './pages/P2pPayment';
import Subscriptions from './pages/subscription';
import Plans from './pages/subscription/Plans';
import Rewards from './pages/reward';
import Customers from './pages/customer';
import Ratings from './pages/rating';
import BusinessRequest from './pages/business';
import BusinessRequestForm from './pages/business/BusinessRequestForm';
import Messaging from './pages/messaging';
import Settings from './pages/settings';
import Payments from './pages/Payments';
import Managers from './pages/members';
import Sms from './pages/messaging/Sms';
import UniversalPaycode from './pages/paycode/UniversalPaycode';
import ManagerLogin from './pages/members/auth/Login';
import ManagerDashboard from './pages/members/dashboard';
import PaycodeVouchers from './pages/members/dashboard/Vouchers';
import MemberTansactions from './pages/members/dashboard/Transactions';
import Notifications from './pages/members/dashboard/Notifications';
import ChangePassword from './pages/members/dashboard/ChangePassword';
import ForgotPasswordMember from './pages/members/auth/ForgotPassword';
import ResetPasswordMember from './pages/members/auth/ResetPassword';
import QrPayment from './pages/QrPayment';
import Announcement from './pages/Announcement';
import { useSelector } from 'react-redux';
import FasePay from './pages/fasepay';
import LoanRequest from './pages/LoanRequest';
import Inventory from './pages/inventory';
import StockRequest from './pages/inventory/StockRequest';
import StockDetails from './pages/inventory/StockDetails';
import TaxCalculator from './pages/TaxCalculator';
import LoyaltyPaycode from './pages/paycode/LoyaltyPaycode';
import StockInventory from './pages/members/inventory/StockInventory';
import TaxCalculatorx from './pages/members/TaxCalculatorx';
import InventoryListing from './pages/inventory/InventoryListing';
import ProductInfo from './pages/inventory/ProductInfo';
import Pricelist from './pages/inventory/Pricelist';
import LoyaltyVoucherHistory from './pages/paycode/LoyaltyVoucherHistory';
import LoyaltyPaycodeManagement from './pages/paycode/web/index';
import SalesTracker from './pages/inventory/SalesTracker';
import ProductPreview from './pages/inventory/ProductPreview';
import VendorList from './pages/inventory/VendorList';
import SellProduct from './pages/inventory/SellProduct';
import AppRoutes from './routes/appRoutes';
import FileVault from './pages/FileVault';
import PettyCash from './pages/PettyCash';
import Accounting from './pages/Accounting';
import Storefront from './pages/inventory/Storefront';
import Orders from './pages/inventory/Orders';
import Products from './pages/inventory/Products';
import PettyCashRequests from './pages/PettyCashRequests';
import MarketPlace from './pages/inventory/MarketPlace';
import OrderDetails from './pages/inventory/OrderDetails';
import OrderHistory from './pages/inventory/OrderHistory';
import Salesforce from './pages/salesforce/Index';
import SalesforceTransactions from './pages/salesforce/SalesforceTransactions';
import SalesforceTransactionsHistory from './pages/salesforce/SalesforceTransactionsHistory';
import Community from './pages/Community';

const privateRoutes = [
  { path: '/', role: '', authRequired: false, exact: true, component: Login },
  { path: '/dashboard', role: "admin", authRequired: true, exact: true, adminRoute: Home },
  { path: '/transactions', role: "admin", authRequired: true, exact: true, adminRoute: Transactions },
  { path: '/invoices', role: "admin", authRequired: true, exact: true, adminRoute: Invoices },
  { path: '/paycodes', role: "admin", authRequired: true, exact: true, adminRoute: Paycode },
  { path: '/fasepay', role: "admin", authRequired: true, exact: true, adminRoute: FasePay },
  { path: '/tickets', role: "admin", authRequired: true, exact: true, adminRoute: Tickets },
  { path: '/tickets/:id', role: "admin", authRequired: true, exact: true, adminRoute: TicketView },
  { path: '/reports', role: "admin", authRequired: true, exact: true, adminRoute: Reports },
  { path: '/vouchers', role: "admin", authRequired: true, exact: true, adminRoute: Voucher },
  { path: '/bills-payment', role: "admin", authRequired: true, exact: true, adminRoute: BillsPayment },
  { path: '/wallets', role: "admin", authRequired: true, exact: true, adminRoute: Wallets },
  { path: '/p2p-payment', role: "admin", authRequired: true, exact: true, adminRoute: P2pPayment },
  { path: '/subscriptions', role: "admin", authRequired: true, exact: true, adminRoute: Plans },
  { path: '/subscriptions/plans', role: "admin", authRequired: true, exact: true, adminRoute: Subscriptions },
  { path: '/rewards', role: "admin", authRequired: true, exact: true, adminRoute: Rewards },
  { path: '/customers', role: "admin", authRequired: true, exact: true, adminRoute: Customers },
  { path: '/managers', role: "admin", authRequired: true, exact: true, adminRoute: Managers },
  { path: '/ratings', role: "admin", authRequired: true, exact: true, adminRoute: Ratings },
  { path: '/business-request', role: "admin", authRequired: true, exact: true, adminRoute: BusinessRequest },
  { path: '/business-request/form', role: "admin", authRequired: true, exact: true, adminRoute: BusinessRequestForm },
  { path: '/messaging', role: "admin", authRequired: true, exact: true, adminRoute: Messaging },
  { path: '/messaging/sms', role: "admin", authRequired: true, exact: true, adminRoute: Sms },
  { path: '/settings', role: "admin", authRequired: true, exact: true, adminRoute: Settings },
  { path: '/announcements', role: "admin", authRequired: true, exact: true, adminRoute: Announcement },
  { path: '/loan-request', role: "admin", authRequired: true, exact: true, adminRoute: LoanRequest },
  { path: '/file-vault', role: "admin", authRequired: true, exact: true, adminRoute: FileVault },
  { path: '/petty-cash', role: "admin", authRequired: true, exact: true, adminRoute: PettyCash },
  { path: '/petty-cash-requests', role: "admin", authRequired: true, exact: true, adminRoute: PettyCashRequests },
  { path: '/simple-accounting', role: "admin", authRequired: true, exact: true, adminRoute: Accounting },


  { path: '/inventory', role: "admin", authRequired: true, exact: true, adminRoute: Inventory },
  { path: '/stock-request', role: "admin", authRequired: true, exact: true, adminRoute: StockRequest },
  { path: '/inventory/stock-details/:id', role: "admin", authRequired: true, exact: true, adminRoute: StockDetails },
  { path: '/inventory/product-listing', role: "admin", authRequired: true, exact: true, adminRoute: InventoryListing },
  { path: '/inventory/product-info/:id', role: "admin", authRequired: true, exact: true, adminRoute: ProductInfo },
  { path: '/inventory/pricelist', role: "admin", authRequired: true, exact: true, adminRoute: Pricelist },
  { path: '/inventory/sales-tracker', role: "admin", authRequired: true, exact: true, adminRoute: SalesTracker },
  { path: '/inventory/vendors', role: "admin", authRequired: true, exact: true, adminRoute: VendorList },
  { path: '/inventory/preview/:id', role: "admin", authRequired: true, exact: true, adminRoute: ProductPreview },
  { path: '/inventory/sell', role: "admin", authRequired: true, exact: true, adminRoute: SellProduct },
  { path: '/tax-calculator', role: "admin", authRequired: true, exact: true, adminRoute: TaxCalculator },
  { path: '/loyalty-voucher', role: "admin", authRequired: true, exact: true, adminRoute: LoyaltyPaycode },
  { path: '/loyalty-voucher/history', role: "admin", authRequired: true, exact: true, adminRoute: LoyaltyVoucherHistory },
  { path: '/loyalty-voucher/history/:paycode_id', role: "admin", authRequired: true, exact: true, adminRoute: LoyaltyVoucherHistory },
  { path: '/inventory/storefront', role: "admin", authRequired: true, exact: true, adminRoute: Storefront },
  { path: '/inventory/storefront/orders', role: "admin", authRequired: true, exact: true, adminRoute: Orders },
  { path: '/inventory/storefront/products', role: "admin", authRequired: true, exact: true, adminRoute: Products },
  { path: '/storefront/orders/:id', role: "admin", authRequired: true, exact: true, adminRoute: OrderDetails },
  { path: '/storefront/orders/daily-history', role: "admin", authRequired: true, exact: true, adminRoute: OrderHistory },
  { path: '/sales-force/agents', role: "admin", authRequired: true, exact: true, adminRoute: Salesforce },
  { path: '/sales-force/transactions', role: "admin", authRequired: true, exact: true, adminRoute: SalesforceTransactionsHistory },
  { path: '/sales-force/transactions/:agentref', role: "admin", authRequired: true, exact: true, adminRoute: SalesforceTransactions },
  { path: '/community', role: "manager", authRequired: true, exact: true, component: Community },
 
  { path: '/members/loyalty-voucher/history', role: "manager", authRequired: true, exact: true, component: LoyaltyVoucherHistory },
  { path: '/members/loyalty-voucher/history/:paycode_id', role: "manager", authRequired: true, exact: true, component: LoyaltyVoucherHistory },
  { path: '/members/bills-payment', role: "manager", authRequired: true, exact: true, component: BillsPayment },
  { path: '/members/fasepay', role: "manager", authRequired: true, exact: true, component: FasePay },
  { path: '/members/p2p-payment', role: "manager", authRequired: true, exact: true, component: P2pPayment },
  { path: '/members/announcements', role: "manager", authRequired: true, exact: true, component: Announcement },
  { path: '/members/messaging', role: "manager", authRequired: true, exact: true, component: Messaging },
  { path: '/members/messaging/sms', role: "manager", authRequired: true, exact: true, component: Sms },
  { path: '/members/invoices', role: "manager", authRequired: true, exact: true, component: Invoices },
  { path: '/members/customers', role: "manager", authRequired: true, exact: true, component: Customers },
  { path: '/members/dashboard', role: "manager", authRequired: true, exact: true, component: ManagerDashboard },
  { path: '/members/paycodes', role: "manager", authRequired: true, exact: true, component: PaycodeVouchers },
  { path: '/members/transactions', role: "manager", authRequired: true, exact: true, component: MemberTansactions },
  { path: '/members/notifications', role: "manager", authRequired: true, exact: true, component: Notifications },
  { path: '/members/change-password', role: "manager", authRequired: true, exact: true, component: ChangePassword },
  { path: '/members/reset-password', role: "", authRequired: false, exact: true, component: ResetPasswordMember },
  { path: '/members/forgot-password', role: "", authRequired: false, exact: true, component: ForgotPasswordMember },
  { path: '/members/login', role: "", authRequired: false, exact: true, component: ManagerLogin },

  { path: '/members/inventory', role: "manager", authRequired: true, exact: true, component: StockInventory },
  { path: '/members/stock-request', role: "manager", authRequired: true, exact: true, component: StockRequest },
  { path: '/members/inventory/product-listing', role: "manager", authRequired: true, exact: true, component: InventoryListing },
  { path: '/members/inventory/stock-details/:id', role: "manager", authRequired: true, exact: true, component: ProductInfo },
  { path: '/members/inventory/sell', role: "manager", authRequired: true, exact: true, component: SellProduct },
  { path: '/members/inventory/pricelist', role: "manager", authRequired: true, exact: true, component: Pricelist },
  { path: '/members/inventory/storefront', role: "manager", authRequired: true, exact: true, component: Storefront },
  { path: '/members/inventory/storefront/orders', role: "manager", authRequired: true, exact: true, component: Orders },
  { path: '/members/inventory/storefront/products', role: "manager", authRequired: true, exact: true, component: Products },
  { path: '/members/storefront/orders/:id', role: "manager", authRequired: true, exact: true, component: OrderDetails },
  { path: '/members/storefront/orders/daily-history', role: "manager", authRequired: true, exact: true, component: OrderHistory },

  { path: '/members/tax-calculator', role: "manager", authRequired: true, exact: true, component: TaxCalculatorx },
  { path: '/members/loyalty-voucher', role: "manager", authRequired: true, exact: true, component: LoyaltyPaycode },
  { path: '/members/inventory/sales-tracker', role: "manager", authRequired: true, exact: true, component: SalesTracker },
  { path: '/members/petty-cash', role: "manager", authRequired: true, exact: true, component: PettyCash },
  { path: '/members/petty-cash-requests', role: "manager", authRequired: true, exact: true, component: PettyCashRequests },
  { path: '/members/sales-force/agents', role: "manager", authRequired: true, exact: true, component: Salesforce },
  { path: '/members/sales-force/transactions', role: "manager", authRequired: true, exact: true, component: SalesforceTransactionsHistory },
  { path: '/members/sales-force/transactions/:agentref', role: "manager", authRequired: true, exact: true, component: SalesforceTransactions },
 

  { path: '/payments', role: "", authRequired: false, exact: true, component: Payments },
  { path: '/payments/qr-pay/:id', role: "", authRequired: false, exact: true, component: QrPayment },
  { path: '/paycodes/generate', role: "", authRequired: false, exact: true, component: UniversalPaycode },
  { path: '/invoices/payment', role: "", authRequired: false, exact: true, component: Payments },
  { path: '/profile-setup', role: "admin", authRequired: true, exact: true, adminRoute: ProfileSetup },
  { path: '/signup', role: "", authRequired: false, exact: true, component: Signup },
  { path: '/reset-password', role: "", authRequired: false, exact: true, component: ResetPassword },
  { path: '/forgot-password', role: "", authRequired: false, exact: true, component: ForgotPassword },
  { path: '/voucher-management', role: "", authRequired: false, exact: true, component: LoyaltyPaycodeManagement },
  { path: '/marketplace/:reference', role: "", authRequired: false, exact: true, component: MarketPlace },

];

function App() {

  const { isLoggedIn, isManager, user } = useSelector(state => state.auth);
  const defaultRoute  = user && user.user_type === 'owner' ? '/' : (isManager ? '/members/login' : '/')
  return AppRoutes({privateRoutes, isLoggedIn, user, defaultRoute})
  // return (
  //   <Routes>
  //     {
  //       privateRoutes.map(route => (
  //         <Route
  //           path={route.path}
  //           key={route.path}
  //           exact={route.exact}
  //           element={
  //             !isLoggedIn && route.authRequired ? <Navigate to={defaultRoute} /> :
  //             isLoggedIn && route.role === 'admin' && !user.user_type !== 'owner' ? <route.adminRoute /> :
  //             isLoggedIn && route.role === 'manager' ? <route.component /> :
  //             !route.authRequired ? <route.component /> : 
  //             <Navigate to={defaultRoute} replace />
  //           }
  //         />
  //       ))
  //     }
  //   </Routes>
  // );
}

export default App;
library.add(fab, fas, far)